import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=66167895&scoped=true"
import script from "./exam.vue?vue&type=script&lang=ts"
export * from "./exam.vue?vue&type=script&lang=ts"
import style0 from "./exam.vue?vue&type=style&index=0&id=66167895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66167895",
  null
  
)

export default component.exports